import { dayjs } from '@studio/js-utils/time';
import { clsx } from 'cn';
import { UserInviteDetails } from './invite-details.jsx';
import type { User } from './types.js';

/** GuestsTab component. */
export const GuestsTab = ({
  guests,
  onDelete,
  onResend,
  updateGuest
}: {
  guests: User[];
  onDelete: (id: string) => () => void;
  onResend: (id: string) => () => void;
  updateGuest: (id: string, update: Partial<User>) => void;
}) => {
  const activeGuests = guests.filter((v) => dayjs(v.expiration).isAfter(dayjs()));
  const inactiveGuests = guests.filter((v) => dayjs(v.expiration).isBefore(dayjs()));

  return (
    <div className='flex flex-col gap-12 text-left'>
      {guests.length === 0 ? (
        <div className='mt-18'>
          <h2>No active guests</h2>
          <div className='text-secondary'>Guests are users with expiration enabled</div>
        </div>
      ) : (
        <div className='flex flex-col gap-y-8'>
          {activeGuests.length > 0 && <h3>Active</h3>}
          {activeGuests.map((guest) => (
            <UserInviteDetails
              key={guest.email}
              onDelete={onDelete(guest.id)}
              onResend={onResend(guest.id)}
              onUpdate={(update: Partial<User>) => {
                updateGuest(guest.id, update);
              }}
              user={guest}
            />
          ))}

          {inactiveGuests.length > 0 && (
            <h3
              className={clsx({
                'mt-16': activeGuests.length > 0
              })}
            >
              Expired
            </h3>
          )}
          {inactiveGuests.map((guest) => (
            <UserInviteDetails
              key={guest.email}
              onDelete={onDelete(guest.id)}
              onResend={onResend(guest.id)}
              onUpdate={(update: Partial<User>) => {
                updateGuest(guest.id, update);
              }}
              user={guest}
            />
          ))}
        </div>
      )}
    </div>
  );
};
